import { trackingPageBlockIds } from '@reveni-io/reveni-ui'

import {
  missingDataTypes,
  notActiveOnTypes,
} from '@/configuration/pages/ConfigurationPage/OrderTrackingPageConfiguration/TrackingPageEditorModal/constants'
import { buildHiddenBlocks } from '@/configuration/pages/ConfigurationPage/OrderTrackingPageConfiguration/TrackingPageEditorModal/helpers'

import { scenarioFallbackReturnAmount, scenarioLineItemReferences, scenarioOperationResultStatuses } from './constants'

const buildScenarioLineItem = (item, templateLineItem) => {
  return {
    ...templateLineItem,
    id: item.id,
    status: item.status,
    shipment_id: item.returned ? null : scenarioLineItemReferences.shipmentId,
    return_id: item.returned ? scenarioLineItemReferences.returnId : null,
  }
}

export const buildScenarioLineItems = ({ scenarioItems, templateLineItems }) => {
  return scenarioItems.map((item, index) => {
    return buildScenarioLineItem(item, templateLineItems[index % templateLineItems.length])
  })
}

const buildScenarioShippingLabels = ({ scenarioShipments, templateShippingLabel }) => {
  return scenarioShipments.map(shipment => {
    return { ...templateShippingLabel, id: shipment.id, status: shipment.status, type: shipment.type }
  })
}

const resolveScenarioLineItems = (lineItems, scenarioItems) => {
  if (lineItems.length === 0) return lineItems

  return buildScenarioLineItems({ scenarioItems, templateLineItems: lineItems })
}

const getScenarioReturnAmount = templateLineItems => {
  const [templateLineItem] = templateLineItems

  if (Number(templateLineItem?.price) > 0) return templateLineItem.price

  return scenarioFallbackReturnAmount
}

export const buildScenarioReturnRequests = ({ scenarioReturnRequests, orderTrackingPreview }) => {
  const amount = getScenarioReturnAmount(orderTrackingPreview.line_items)
  const date = new Date().toISOString()

  return scenarioReturnRequests.map(returnRequest => {
    return {
      id: returnRequest.id,
      requested_at: date,
      ...scenarioOperationResultStatuses[returnRequest.operationResult],
      refund_amount: amount,
      payment_amount: amount,
      currency: orderTrackingPreview.store.currency,
    }
  })
}

export const resolveOrderTrackingPreview = ({
  orderTrackingPreview,
  scenarioItems,
  scenarioShipments,
  scenarioReturnRequests,
}) => {
  if (!orderTrackingPreview) return orderTrackingPreview

  const [templateShippingLabel] = orderTrackingPreview.shipping_labels

  return {
    ...orderTrackingPreview,
    line_items: resolveScenarioLineItems(orderTrackingPreview.line_items, scenarioItems),
    shipping_labels: buildScenarioShippingLabels({ scenarioShipments, templateShippingLabel }),
    return_requests: buildScenarioReturnRequests({ scenarioReturnRequests, orderTrackingPreview }),
  }
}

const getScenarioMissingDataBlocks = ({ scenarioItems, scenarioShipments, scenarioReturnRequests }) => {
  const scenarioDataChecks = [
    {
      blockId: trackingPageBlockIds.orderItems,
      missingData: missingDataTypes.scenarioItems,
      isDataMissing: scenarioItems.length === 0,
    },
    {
      blockId: trackingPageBlockIds.shipments,
      missingData: missingDataTypes.scenarioShipments,
      isDataMissing: scenarioShipments.length === 0,
    },
    {
      blockId: trackingPageBlockIds.returnRequests,
      missingData: missingDataTypes.scenarioReturnRequests,
      isDataMissing: scenarioReturnRequests.length === 0,
    },
  ]

  return scenarioDataChecks.filter(check => check.isDataMissing)
}

export const getHiddenBlocks = ({
  scenarioItems,
  scenarioShipments,
  scenarioReturnRequests,
  dateLimitedBlocks,
  criteriaLimitedBlocks,
}) => {
  const missingDataBlocks = getScenarioMissingDataBlocks({
    scenarioItems,
    scenarioShipments,
    scenarioReturnRequests,
  })

  return buildHiddenBlocks({
    missingDataBlocks,
    dateLimitedBlocks,
    notActiveOn: notActiveOnTypes.previewDate,
    criteriaLimitedBlocks,
  })
}
